/**
 * Données des services - Olney Tech Solutions
 * Utilisé sur la page d'accueil et les pages de services dédiées
 */

export const services = [
  {
    id: 'developpement-web',
    slug: 'developpement-web',
    title: 'Développement Web',
    shortTitle: 'Dev Web',
    icon: 'WebDevelopment',
    color: 'primary',
    tagline: 'Sites vitrines et e-commerce ultra-performants',
    description: 'Sites vitrines et e-commerce ultra-performants. Architecture moderne (React, Node.js) pour une vitesse et une sécurité maximales.',
    fullDescription: `Nous créons des sites web sur mesure qui transforment vos visiteurs en clients. Notre approche combine design moderne, performance optimale et expérience utilisateur exceptionnelle.

Chaque projet est développé avec les technologies les plus récentes pour garantir rapidité, sécurité et évolutivité. Que vous ayez besoin d'un site vitrine élégant ou d'une plateforme e-commerce complète, nous adaptons notre solution à vos objectifs.`,
    features: [
      'Design Responsive & Mobile First',
      'Optimisation SEO Technique',
      'Performance & Vitesse (Core Web Vitals)',
      'Interface utilisateur intuitive',
      'Intégration CMS personnalisé',
      'Hébergement haute disponibilité'
    ],
    benefits: [
      { title: 'Visibilité accrue', description: 'Positionnement optimal sur Google grâce à notre expertise SEO technique' },
      { title: 'Conversion optimisée', description: 'Design pensé pour convertir vos visiteurs en clients' },
      { title: 'Évolutivité', description: 'Architecture scalable qui grandit avec votre entreprise' }
    ],
    technologies: ['React', 'Next.js', 'Node.js', 'Tailwind CSS', 'WordPress', 'Shopify'],
    pricing: {
      starting: 500,
      unit: '€',
      description: 'à partir de 500€ + 150€/mois'
    },
    cta: 'Créer mon site',
    metaTitle: 'Développement Web à Lille | Sites Vitrines & E-commerce | Olney Tech',
    metaDescription: 'Création de sites web modernes et performants à Lille. Sites vitrines, e-commerce, applications web. Design responsive, SEO optimisé, livraison rapide.'
  },
  {
    id: 'seo-visibilite',
    slug: 'seo-referencement',
    title: 'SEO & Visibilité',
    shortTitle: 'SEO',
    icon: 'Search',
    color: 'secondary',
    tagline: 'Dominez les résultats de recherche',
    description: 'Dominez les résultats de recherche. Stratégies SEO locales et nationales pour attirer un trafic qualifié et convertir.',
    fullDescription: `Le référencement naturel est la clé pour attirer des clients qualifiés sans publicité payante. Notre approche SEO combine expertise technique, contenu optimisé et stratégie de liens pour propulser votre site en première page de Google.

Nous nous spécialisons particulièrement dans le SEO local pour les entreprises des Hauts-de-France, vous permettant de dominer les recherches dans votre zone de chalandise.`,
    features: [
      'Audit SEO Complet',
      'Optimisation Google My Business',
      'Stratégie de Contenu & Backlinks',
      'Recherche de mots-clés',
      'Optimisation technique on-page',
      'Suivi et reporting mensuel'
    ],
    benefits: [
      { title: 'Trafic qualifié', description: 'Attirez des visiteurs qui recherchent activement vos services' },
      { title: 'ROI durable', description: 'Investissement qui génère des résultats sur le long terme' },
      { title: 'Visibilité locale', description: 'Dominez les recherches dans votre zone géographique' }
    ],
    technologies: ['Google Search Console', 'SEMrush', 'Ahrefs', 'Google Analytics', 'Screaming Frog'],
    pricing: {
      starting: 300,
      unit: '€/mois',
      description: 'à partir de 300€/mois'
    },
    cta: 'Améliorer mon SEO',
    metaTitle: 'Référencement SEO à Lille | Agence SEO Hauts-de-France | Olney Tech',
    metaDescription: 'Expert SEO à Lille. Optimisation Google, référencement local, stratégie de contenu. Augmentez votre visibilité et attirez plus de clients qualifiés.'
  },
  {
    id: 'maintenance-securite',
    slug: 'maintenance-securite',
    title: 'Maintenance & Sécurité',
    shortTitle: 'Maintenance',
    icon: 'Shield',
    color: 'accent',
    tagline: 'Dormez sur vos deux oreilles',
    description: 'Dormez sur vos deux oreilles. Nous gérons la technique, les mises à jour et la sécurité de votre infrastructure.',
    fullDescription: `Un site web nécessite une maintenance régulière pour rester performant et sécurisé. Notre service de maintenance proactive vous libère de tout souci technique.

Nous surveillons votre site 24/7, effectuons les mises à jour de sécurité, optimisons les performances et intervenons rapidement en cas de problème. Votre site reste toujours opérationnel et protégé.`,
    features: [
      'Sauvegardes Quotidiennes',
      'Protection Anti-Piratage',
      'Mises à jour & Monitoring 24/7',
      'Certificat SSL inclus',
      'Optimisation des performances',
      'Support technique prioritaire'
    ],
    benefits: [
      { title: 'Sérénité totale', description: 'Ne vous souciez plus des aspects techniques de votre site' },
      { title: 'Protection maximale', description: 'Votre site et vos données sont protégés en permanence' },
      { title: 'Disponibilité garantie', description: 'Votre site reste accessible 24/7 avec intervention rapide' }
    ],
    technologies: ['Cloudflare', 'Sucuri', 'UpdraftPlus', 'Wordfence', 'ManageWP'],
    pricing: {
      starting: 150,
      unit: '€/mois',
      description: '150€/mois tout inclus'
    },
    cta: 'Protéger mon site',
    metaTitle: 'Maintenance Web & Sécurité à Lille | Support 24/7 | Olney Tech',
    metaDescription: 'Maintenance de sites web à Lille. Sauvegardes, mises à jour, sécurité, monitoring 24/7. Protégez votre site et dormez sur vos deux oreilles.'
  },
  {
    id: 'cybersecurite',
    slug: 'cybersecurite',
    title: 'Cybersécurité',
    shortTitle: 'Sécurité',
    icon: 'Cybersecurity',
    color: 'success',
    tagline: 'Forteresse numérique pour vos données',
    description: 'Forteresse numérique. Audits de pénétration, chiffrement des données et conformité RGPD pour protéger vos actifs.',
    fullDescription: `Les cyberattaques ciblent de plus en plus les PME. Notre expertise en cybersécurité protège votre entreprise contre les menaces modernes.

Nous réalisons des audits complets, identifions les vulnérabilités et mettons en place des mesures de protection adaptées. Conformité RGPD, chiffrement des données, formation des équipes : nous sécurisons tous les aspects de votre infrastructure.`,
    features: [
      'Audit de sécurité complet',
      'Tests de pénétration',
      'Conformité RGPD',
      'Chiffrement des données',
      'Formation des équipes',
      'Plan de réponse aux incidents'
    ],
    benefits: [
      { title: 'Protection des données', description: 'Vos données sensibles sont protégées contre les fuites' },
      { title: 'Conformité légale', description: 'Respectez les exigences RGPD et évitez les amendes' },
      { title: 'Réputation préservée', description: 'Évitez les dommages réputationnels liés aux cyberattaques' }
    ],
    technologies: ['OWASP', 'Nessus', 'Burp Suite', 'Metasploit', 'Kali Linux'],
    pricing: {
      starting: 800,
      unit: '€',
      description: 'Audit à partir de 800€'
    },
    cta: 'Sécuriser mon entreprise',
    metaTitle: 'Cybersécurité PME à Lille | Audit & Protection | Olney Tech',
    metaDescription: 'Expert cybersécurité pour PME à Lille. Audits de sécurité, tests de pénétration, conformité RGPD, protection des données. Protégez votre entreprise.'
  },
  {
    id: 'applications-mobiles',
    slug: 'applications-mobiles',
    title: 'Applications Mobiles',
    shortTitle: 'Apps',
    icon: 'MobileApps',
    color: 'secondary',
    tagline: 'Votre business dans la poche de vos clients',
    description: 'Expérience native iOS et Android. Des applications fluides, intuitives et performantes qui restent dans la poche de vos clients.',
    fullDescription: `Une application mobile bien conçue renforce la relation avec vos clients et ouvre de nouvelles opportunités commerciales.

Nous développons des applications natives et cross-platform (React Native) qui offrent une expérience utilisateur optimale sur iOS et Android. Du concept au déploiement sur les stores, nous vous accompagnons à chaque étape.`,
    features: [
      'Applications iOS & Android',
      'Design UI/UX mobile-first',
      'Notifications push',
      'Fonctionnement hors-ligne',
      'Intégration API & backend',
      'Publication sur App Store & Play Store'
    ],
    benefits: [
      { title: 'Engagement client', description: 'Restez connecté avec vos clients où qu\'ils soient' },
      { title: 'Nouvelles fonctionnalités', description: 'GPS, caméra, notifications : exploitez le mobile' },
      { title: 'Image moderne', description: 'Montrez que votre entreprise est à la pointe' }
    ],
    technologies: ['React Native', 'Expo', 'Swift', 'Kotlin', 'Firebase', 'App Store Connect'],
    pricing: {
      starting: 5000,
      unit: '€',
      description: 'à partir de 5000€'
    },
    cta: 'Créer mon app',
    metaTitle: 'Développement Application Mobile à Lille | iOS & Android | Olney Tech',
    metaDescription: 'Création d\'applications mobiles à Lille. Apps iOS, Android, React Native. Design intuitif, notifications push, publication sur les stores.'
  },
  {
    id: 'automatisation-ia',
    slug: 'automatisation-ia',
    title: 'Automatisation & IA',
    shortTitle: 'IA',
    icon: 'AI',
    color: 'primary',
    tagline: 'Travaillez plus intelligemment, pas plus dur',
    description: 'Automatisez vos processus répétitifs avec l\'intelligence artificielle. Chatbots, workflows automatisés, analyse de données.',
    fullDescription: `L'automatisation et l'IA transforment la façon dont les entreprises travaillent. Nous vous aidons à identifier et automatiser les tâches répétitives pour libérer du temps pour ce qui compte vraiment.

Des chatbots intelligents pour votre service client aux workflows automatisés avec Make/Zapier, nous implémentons des solutions qui augmentent votre productivité et réduisent vos coûts.`,
    features: [
      'Chatbots IA intelligents',
      'Workflows automatisés',
      'Intégration CRM',
      'Analyse de données',
      'Email marketing automatisé',
      'Prise de RDV automatique'
    ],
    benefits: [
      { title: 'Gain de temps', description: 'Automatisez les tâches répétitives et chronophages' },
      { title: 'Disponibilité 24/7', description: 'Vos chatbots répondent même quand vous dormez' },
      { title: 'Réduction des erreurs', description: 'Les processus automatisés sont plus fiables' }
    ],
    technologies: ['Claude AI', 'OpenAI', 'Make (Integromat)', 'Zapier', 'n8n', 'Cal.com'],
    pricing: {
      starting: 1500,
      unit: '€',
      description: 'à partir de 1500€'
    },
    cta: 'Automatiser mon business',
    metaTitle: 'Automatisation & Intelligence Artificielle à Lille | Olney Tech',
    metaDescription: 'Automatisation des processus et IA pour PME à Lille. Chatbots intelligents, workflows automatisés, intégration CRM. Gagnez du temps et de l\'argent.'
  }
];

export const getServiceBySlug = (slug) => services.find(s => s.slug === slug);
export const getServiceById = (id) => services.find(s => s.id === id);
